<template>
  <div class="card">
    <b-modal
      id="modal_form"
      ref="modal_form"
      v-model="showModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
    >
      <template #modal-header>
        <h5 class="modal-title font-weight-bold">
          Finalizar Conferência
        </h5>
      </template>

      <div class="loadingData d-flex justify-content-center align-items-center" v-if="loadingData">
        <div class="loadingDataSpinner">
          <spinner text-fg-color="#ffffff" message="Carregando..."></spinner>
        </div>
      </div>

      <b-row class="mb-1">
        <b-col>
          <h5 class="text-center text-secondary font-weight-bold">
            Total geral de volumes de todas as áreas
          </h5>
        </b-col>
      </b-row>
      <hr class="mb-2" />

      <b-row class="text-center mb-1">
        <b-col md="4">
          <h6>Bipados</h6>

          <p class="font-weight-bold h2">{{ sumBipados }}</p>
        </b-col>

        <b-col md="4">
          <h6>Não bipados</h6>

          <p class="font-weight-bold h2">{{ sumNotBipados }}</p>
        </b-col>

        <b-col md="4">
          <h6>Total</h6>

          <p class="font-weight-bold h2">{{ sumTotal }}</p>
        </b-col>
      </b-row>

      <vuetable
        ref="vuetable"
        :data="tableData"
        :api-mode="false"
        :fields="fields"
        :css="css"
        :per-page="10"
        pagination-path=""
        @vuetable:loaded="onLoaded"
        no-data-template="Não foram encontrados os detalhes da bipagem por área."
      >
        <template slot="area" slot-scope="props">
          {{ props.rowData.area }}
        </template>

        <template slot="beeped" slot-scope="props">
          {{ props.rowData.beeped }}
        </template>

        <template slot="not_beeped" slot-scope="props">
          {{ props.rowData.not_beeped }}
        </template>

        <template slot="total" slot-scope="props">
          {{ props.rowData.total }}
        </template>
      </vuetable>

      <b-row v-if="userMessage !== ''" class="justify-content-center mb-0">
        <b-col md="8">
          <b-alert
            :variant="alertVariant"
            show
            class="d-flex align-items-center justify-content-center py-1"
          >
            <i :class="alertIcon" class="mr-1" style="font-size: 1.3rem;"></i>

            <span class="h5 mb-0">{{ userMessage }}</span>
          </b-alert>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-btn @click="onCancel" variant="secondary">
          Cancelar
        </b-btn>

        <b-btn
          @click="handleFinish"
          variant="secondary"
          :disabled="isFinishDisabled"
        >
          Finalizar
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.loadingData {
  position: absolute;
  top:    0;
  left:   0;
  width:  100%;
  height: 100%;
  background-color: rgba(77, 87, 87, 0.459);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 9999;
}

.loadingDataSpinner {
  padding: 1rem;
  background: rgba(0, 0, 0, 0.185);
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0,0,0,0.10);
}
</style>

<script>
import Vuetable from "../components/Vuetable";
import { DeviceSizeEnum } from "../enums/GeneralEnums";

export default {
  components: {
    Vuetable,
  },
  data() {
    return {
      showModal: false,
      loadingData: false,
      tableData: [],
      finishIsDisabled: true,
      hasPendingVolumes: false,
      allRowsHaveBeeps: false,
      groupId: null,
      moreParams: {},
      DeviceSizeEnum,
      fields: [
        {
          name: 'area',
          title: 'Área',
          titleClass: 'text-left',
          dataClass: 'text-left'
        },
        {
          name: 'beeped',
          title: 'Bipados',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'not_beeped',
          title: 'Não bipados',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'total',
          title: 'Total',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],
      css: {
        tableClass: 'table table-hover table-bordered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger'
      },
    };
  },
  computed: {
    sumBipados() {
      return this.tableData.reduce((acc, row) => acc + (row.beeped || 0), 0);
    },
    sumNotBipados() {
      return this.sumTotal - this.sumBipados;
    },
    sumTotal() {
      return this.tableData.reduce((acc, row) => acc + (row.total || 0), 0);
    },
    isFinishDisabled() {
      if (this.loadingData || this.tableData.length === 0) {
        return true;
      }

      const hasSpecialFinished = this.getPermissionFw('conferencia_volume.botao.finalizar_especial');
      if (hasSpecialFinished) {
        return false;
      }

      if (!this.allRowsHaveBeeps) {
        return true;
      }

      return this.hasPendingVolumes;
    },
    userMessage() {
      if (this.sumTotal <= 0) {
        return "";
      }

      if (!this.allRowsHaveBeeps) {
        return `Para finalizar, todas as áreas do grupo de triagem selecionado devem ter pelo menos 1(um) volume bipado.`;
      }

      const hasSpecialFinished = this.getPermissionFw('conferencia_volume.botao.finalizar_especial');
      if (this.hasPendingVolumes) {
        if(hasSpecialFinished) {
          return `Há ${this.sumNotBipados} pendências na conferência, os itens serão salvos como falta. Deseja finalizar mesmo assim?`;
        } else {
          return `Existem ${this.sumNotBipados} volumes pendentes. Contate o administrador para liberar a finalização.`;
        }
      }

      return `Todos os volumes foram bipados com sucesso! Clique em "Finalizar" para concluir.`;
    },
    alertVariant() {
      if (!this.allRowsHaveBeeps) {
        return "danger";
      }

      if (this.hasPendingVolumes) {
        return "info";
      }

      return "success";
    },
    alertIcon() {
      const variant = this.alertVariant;

      switch (variant) {
        case "info": return "fa fa-info-circle";
        case "danger":  return "fa fa-times-circle";
        case "success": return "fa fa-check-circle";
      }
    },
  },
  methods: {
    onCreate(areaId, groupId, batchs, manifestKey, triagemId) {
      this.showModal = true;
      this.groupId = groupId;
      this.batchs = batchs;
      this.manifestKey = manifestKey;
      this.areaId = areaId;
      this.triagemId = triagemId;
      this.tableData = [];
      this.fetchSummary(areaId);
    },
    onLoaded() {
      this.loadingData = false;
    },
    onDetail(row) {
      this.$refs.vuetable.toggleDetailRow(row.volumeId);
    },
    onFinish(groupId) {
      this.loadingData = true;

      const params = {};
      if (this.batchs) {
        params.lote = this.batchs;
      }

      if (this.manifestKey) {
        params.chave_mdfe = this.manifestKey;
      }

      if (this.areaId) {
        params.area_id = this.areaId;
      }

      if (this.triagemId) {
        params.pargrutri_id = this.triagemId;
      }
      new Form({
        ...params
      })
        .post(`/api/conferencia_volume/grupo/${groupId}/finalizar`)
        .then(() => {
          this.loadingData = false;
          this.$Simplert.open({
            title: "Sucesso",
            message: "Conferência finalizada com sucesso!",
            customCloseBtnText: "Fechar",
            type: "success",
          });

          this.resetAll({ andCloseModal: true, isFinish: true });
        })
        .catch(errors => {
          this.loadingData = false;
          return new ReturnApi(errors, this);
        });
    },
    resetAll({ andCloseModal = false, isFinish = false } = {}) {
      this.finishIsDisabled = true;
      this.batchs = null;
      this.manifestKey = null;
      this.tableData = [];
      if(isFinish){
        this.$parent.area.input = "";
        this.$parent.plate.input = "";
        this.$parent.pallet.input = "";
        this.$parent.batch.input = "";
        this.$parent.mdfe.input = "";
        this.$parent.barcode.input = "";
        this.$parent.finishedInvoiceQuantity = 0;
        this.$parent.volumesBiped = 0;
        this.$parent.finishedInvoiceWeight = 0;
        this.$parent.volumesTotal = 0;
        this.$parent.triagem = null;
        this.$parent.finishIsDisabled = true;
      }

      if (andCloseModal) this.showModal = false;
    },
    onCancel() {
      this.$Simplert.open({
        title: "Atenção",
        message: "Deseja cancelar a finalização da conferência?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => {
          this.resetAll({ andCloseModal: true });
        },
      });
    },
    fetchSummary(areaId) {
      this.loadingData = true;

      const queryParams = new URLSearchParams();
      if (this.batchs) {
        queryParams.append('lote', this.batchs);
      }

      if (this.manifestKey) {
        queryParams.append('chave_mdfe', this.manifestKey);
      }

      if (this.groupId) {
        queryParams.append('docfisvolbipgrp_id', this.groupId);
      }

      if (this.triagemId) {
        queryParams.append('pargrutri_id', this.triagemId);
      }

      new Form({})
        .post(`/api/conferencia_volume/area/${areaId}/volumes_pendentes?${queryParams.toString()}`)
        .then(response => {
          this.hasPendingVolumes = response.volumes_pendentes;
          if (response && response.bips_por_area) {
            Object.values(response.bips_por_area).forEach(item => {
              this.tableData.push({
                area: item.area.descr,
                beeped: item.bipados || 0,
                not_beeped: item.sem_bip || 0,
                total: item.total || 0
              });
            });
          }
          this.allRowsHaveBeeps = this.tableData.every(row => row.beeped > 0);
          this.loadingData = false;
        })
        .catch(errors => {
          this.loadingData = false;
          return new ReturnApi(errors, this);
        });
    },
    handleFinish() {
      const hasSpecialFinished = this.getPermissionFw('conferencia_volume.botao.finalizar_especial');

      if (this.hasPendingVolumes && !hasSpecialFinished) {
        return;
      }

      const groupId = this.groupId;

      this.onFinish(groupId);
    },
  },
  watch: {
    tableData: {
      handler(newData) {
        this.$nextTick(() => {
          if (this.$refs.vuetable) {
            this.$refs.vuetable.refresh();
          }
        });
      },
      deep: true
    }
  },
};
</script>
